module.exports = __webpack_public_path__ + "img/lucas-mccallum-portrait-1.c2038ec6.jpg";